import * as Sentry from '@sentry/nextjs'
import { sentryClientOptions } from 'sentry/options'

Sentry.init(sentryClientOptions)
